var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3598 18.5603H16.6398C15.9609 18.5603 15.3097 18.83 14.8296 19.3101C14.3495 19.7902 14.0798 20.4413 14.0798 21.1203V41.6003C14.0798 42.2793 14.3495 42.9304 14.8296 43.4105C15.3097 43.8906 15.9609 44.1603 16.6398 44.1603H47.3598C48.0388 44.1603 48.6899 43.8906 49.17 43.4105C49.6501 42.9304 49.9198 42.2793 49.9198 41.6003V21.1203C49.9198 20.4413 49.6501 19.7902 49.17 19.3101C48.6899 18.83 48.0388 18.5603 47.3598 18.5603ZM44.5438 21.1203L31.9998 29.7987L19.4558 21.1203H44.5438ZM16.6398 41.6003V22.2851L31.2702 32.4099C31.4845 32.5585 31.7391 32.6382 31.9998 32.6382C32.2606 32.6382 32.5152 32.5585 32.7294 32.4099L47.3598 22.2851V41.6003H16.6398Z",
    fill: "#4540DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEmail);
export default __webpack_public_path__ + "static/media/Profile_Email.f69ee6226927c7105840bf52cc4e2d50.svg";
export { ForwardRef as ReactComponent };